import React from 'react';
import PropTypes from 'prop-types';

const Loader = (props) => (
  <div className={`loader ${props.className}`}>
    <svg className="spinner" viewBox="0 0 50 50">
      <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="3" />
    </svg>
  </div>
);

Loader.propTypes = {
  className: PropTypes.string,
};

Loader.defaultProps = {
  className: '',
};

export default Loader;
